import { observable, action, decorate, toJS } from 'mobx';

class MailChimpStore {
  constructor() {
    this.connections = [];
    this.wixContactLabels = [];
    this.mailChimpContactLabels = [];
  }

  setupConnections = (connections) =>
    this.connections.splice(0, this.connections.length, ...connections);

  addConnection = (connection) =>
    this.connections.push({ ...connection, valid: true });

  removeConnection = (connectionUID) =>
    (this.connections = this.connections.filter(
      (c) => c.uid !== connectionUID,
    ));

  connectionExist(srcId, dstId) {
    return this.connections.some(
      (connection) =>
        connection.fromWixLabelId === srcId &&
        connection.toMailChimpId === dstId,
    );
  }

  get connectionsArray() {
    return toJS(this.connections);
  }

  findConnectionByUID(connectionUID) {
    return this.connections.find((c) => c.uid === connectionUID) || {};
  }

  setAPI = (api) => (this.api = api);

  setWixContactLabels = (wixContactLabels) =>
    (this.wixContactLabels = wixContactLabels);

  get wixContactLabelsArray() {
    return toJS(this.wixContactLabels);
  }

  get mailChimpContactLabelsArray() {
    return toJS(this.mailChimpContactLabels);
  }

  setMailChimpContactLabels = (mailChimpContactLabels) =>
    (this.mailChimpContactLabels = mailChimpContactLabels);
}

export default decorate(MailChimpStore, {
  connections: observable,
  wixContactLabels: observable,
  mailChimpContactLabels: observable,
  setupConnections: action,
  addConnection: action,
  removeConnection: action,
  setWixContactLabels: action,
  setMailChimpContactLabels: action,
});
